import React from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Input } from '../../../../components/ui/input'
import { useGlobalContext } from '../../../../context/ContextGlobal'
import { Page } from '../../../../components/layouts/page'
import { TransformationforMask } from '../../../../utils/masks'
import { GetStatusClient } from '../../../administration/clients/_utils'
import { useInfoEnterprise } from './_hooks/useInfoEnterprise'
import { Button } from '../../../../components/ui/button'
import { File } from '../../../../components/ui/file'

export const ClientInfoEnterprise = () => {
  const { user } = useGlobalContext()
  const cliente = user?.client || ''

  const { navbarColor, setNavbarColor, formContext, setFormContext, handleSaveColor, handleUploadLogo } =
    useInfoEnterprise()

  return (
    <>
      {/* <strong>{TransformationforMask(cliente?.id, 'title')}</strong> */}

      <Page.Section className="is-fullheight-with-navbar">
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-5">
              <strong>{TransformationforMask(cliente?.razaoSocial, 'title')}</strong>
            </p>
          </Column.Content>
        </Column.Root>

        <Column.Root>
          <Column.Content size="is-10">
            <Input.Root>
              <Input.Label className="has-text-grey-light">CPF / CNPJ</Input.Label>
              <Input.Contents>
                <Input.ReadOnly className="is-rounded">{cliente?.cpfCnpj}</Input.ReadOnly>
              </Input.Contents>
            </Input.Root>

            <Input.Root>
              <Input.Label className="has-text-grey-light">Situação</Input.Label>
              <Input.Contents>
                <Input.ReadOnly className="is-rounded">{GetStatusClient(cliente?.status).value}</Input.ReadOnly>
              </Input.Contents>
            </Input.Root>

            <Column.Root className="mt-2">
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Inscrição Estadual</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.isncEstadual}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">CNAE</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.cnae}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content></Column.Content>
            </Column.Root>

            <div className="my-3">
              <Column.Root>
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Logradouro</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.endereco}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Número</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.endereco_numero}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>

              <Column.Root>
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Complemento</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.complemento}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Bairro</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.bairro}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>

              <Column.Root className="my-3">
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Municipio</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.endereco}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
                <Column.Content>
                  <Input.Root>
                    <Input.Label className="has-text-grey-light">Cep</Input.Label>
                    <Input.Contents>
                      <Input.ReadOnly className="is-rounded">{cliente?.cep}</Input.ReadOnly>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>
            </div>

            <Column.Root className="my-3">
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Responsavel</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.reponsavel_name}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>

              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Telefone</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.responsavel_telefone}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">E-mail Principal</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.responsavel_email}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>

            <Column.Root className="my-3">
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Banco</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.reponsavel_name}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>

              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Conta</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.responsavel_telefone}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Agência</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.responsavel_email}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>

              <Column.Content>
                <Input.Root>
                  <Input.Label className="has-text-grey-light">Pix</Input.Label>
                  <Input.Contents>
                    <Input.ReadOnly className="is-rounded">{cliente?.responsavel_email}</Input.ReadOnly>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>

            <Column.Root className="my-3">
              <Column.Content>
                <Input.Label className="has-text-grey-light">Cor do Sistema</Input.Label>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2rem' }}>
                  <input
                    type="color"
                    value={navbarColor}
                    onChange={(e) => {
                      setNavbarColor(e.target.value)
                    }}
                  />
                  <Button.Bt
                    className="ml-4"
                    action={() => {
                      handleSaveColor()
                    }}
                  >
                    Salvar cor
                  </Button.Bt>
                  <Button.Bt
                    className="ml-4"
                    action={() => {
                      setNavbarColor('#210057')
                    }}
                  >
                    Resetar Cor
                  </Button.Bt>
                </div>
                <Input.Label className="has-text-grey-light">Insira a Logo da sua empresa</Input.Label>
                <span style={{ color: 'red', fontSize: '.85rem' }}>
                  A imagem a ser inserida deve ter exatamente o tamanho de 500x500 pixels.
                </span>
                <div style={{ marginTop: '2rem' }}>
                  {formContext?.logoUrl ? (
                    String(formContext?.logoUrl).includes('https://') ? (
                      <img
                        alt="photoUrl"
                        src={formContext?.logoUrl}
                        style={{ width: '20%', borderRadius: '50%' }}
                        className="has-shadow"
                      ></img>
                    ) : (
                      <img
                        alt="photoUrl"
                        src={formContext?.logoUrl && URL.createObjectURL(formContext?.logoUrl)}
                        style={{ width: '20%', borderRadius: '50%' }}
                        className="has-shadow"
                      ></img>
                    )
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    width: '400px',
                    flexDirection: 'column',
                    gap: '2rem',
                  }}
                >
                  <File.Root className="mt-5">
                    <File.Input setFile={setFormContext} field={'logoUrl'} accepts="image/*" />
                    <File.Contents>
                      <File.Label>
                        {formContext?.photoUrl?.name
                          ? String(formContext?.photoUrl?.name).slice(0, 20).replace('.png', '') +
                            '.' +
                            String(formContext?.photoUrl?.type).replace('image/', '')
                          : 'Escolha uma imagem...'}
                      </File.Label>
                    </File.Contents>
                  </File.Root>
                  <Column.Root>
                    <Column.Content>
                      <Button.Bt
                        className="mr-5"
                        action={() => {
                          handleUploadLogo()
                        }}
                      >
                        Salvar Logo
                      </Button.Bt>
                      <Button.Bt action={() => setFormContext((prev) => ({ ...prev, logoUrl: null }))}>
                        Resetar Logo
                      </Button.Bt>
                    </Column.Content>
                  </Column.Root>
                </div>
              </Column.Content>
            </Column.Root>
          </Column.Content>
        </Column.Root>
      </Page.Section>
    </>
  )
}
